import { useEffect } from 'react';

/**
 * Custom hook to dynamically update document title and meta description.
 * 
 * @param {string} title - The page title
 * @param {string} description - The page meta description
 */
export default function useMeta(title, description) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }

    // Find or create description meta tag
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    
    if (description) {
      metaDesc.setAttribute('content', description);
    }

    // Clean up or reset on unmount if needed
    return () => {
      // Optional: reset to default title
    };
  }, [title, description]);
}
